// сообщения об ошибках
export const messages = {
  maxLength(count: number) {
    return `Не должно превышать ${count} символов`
  },
  required() {
    return 'Обязательно для заполнения'
  },
  email() {
    return 'Введите корректный e-mail'
  },
}
